var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VBtn',{staticClass:"ml-4 mb-4",attrs:{"color":"white","fab":"","fixed":"","bottom":"","left":"","href":"https://open.spotify.com/show/31F2y4mcb82OmGrJ2whhOA?si=ec3b0bc109ea440b","target":"_blank"}},[_c('VImg',{staticClass:"mx-auto",attrs:{"src":require('@/assets/podcast.svg'),"contain":"","eager":"","width":"50","height":"50"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }